
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.232 39.413a1.232 1.232 0 01-.871-2.103l7.123-7.123a1.232 1.232 0 011.742 1.742l-7.123 7.123c-.24.24-.556.361-.871.361zM3.325 46.87a1.194 1.194 0 01-.845-2.039l7.198-7.199a1.194 1.194 0 111.69 1.69L4.168 46.52a1.19 1.19 0 01-.844.35zM48.613.387c-.3-.3-.726-.438-1.145-.37-.154.025-3.82.627-8.815 2.535a53.625 53.625 0 00-8.276 3.985c-3.214 1.914-6.084 4.125-8.531 6.572-4.13 4.129-7.504 9.336-10.029 15.477a1.323 1.323 0 00.288 1.438l2.5 2.5 2.54 2.54c.516-.517 4.463-8.704 4.979-8.188.517.517-.57-5.644-1.086-5.128l-4.562 12.647 2.5 2.5a1.323 1.323 0 001.438.288c6.141-2.525 11.348-5.9 15.477-10.029 2.447-2.446 4.658-5.317 6.572-8.53a53.6 53.6 0 003.985-8.276c1.908-4.996 2.51-8.662 2.535-8.815.068-.42-.07-.845-.37-1.146zM36.705 18.946a4.671 4.671 0 01-3.325 1.377 4.673 4.673 0 01-3.326-1.377 4.672 4.672 0 01-1.377-3.326c0-1.256.49-2.436 1.378-3.325a4.672 4.672 0 013.325-1.377c1.256 0 2.437.49 3.325 1.377a4.708 4.708 0 010 6.65zM10.819 49a1.232 1.232 0 01-.871-2.103l7.123-7.123a1.232 1.232 0 111.742 1.742l-7.123 7.123c-.24.24-.556.361-.871.361zM19.174 13.848l-6.756 1.172c-.262.045-.503.16-.692.327l-9.2 8.171c-.42.373-.516.945-.239 1.41.237.397.697.637 1.188.637.085 0 .171-.007.257-.022l7.891-1.369c2.081-3.903 4.61-7.361 7.55-10.326zM24.826 37.377l-1.37 7.89c-.1.582.15 1.168.615 1.445.177.106.37.158.561.158.312 0 .62-.136.85-.396l8.17-9.2c.169-.19.283-.43.328-.693l1.172-6.755c-2.965 2.94-6.423 5.47-10.326 7.55z","fill":"#006733"}})])
          )
        }
      }
    